const initialState = {
    reintentos: 0
};

export const reintentosVU = (state = initialState, action) => {
    switch (action.type) {
        case 'VU_REINTENTOS':
            return {
                reintentos: action.intents
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/reintentosVU.js